import { BaseDTO } from "../basedto";
import { InfoButtonDocument } from "../infobutton-document";
import { InfoButtonImage } from "../infobutton-image";

export class InfoButtonDisplayDTO extends BaseDTO {
    CustomText: string;
    ImageInfo: InfoButtonImage[];
    DocumentInfo: InfoButtonDocument[];
    constructor() {
        super();
        this.ImageInfo = [];
        this.DocumentInfo = [];
    }
}
